module.exports = {
  "serverUrl": "https://pryp2j7h58.execute-api.ap-northeast-1.amazonaws.com/prod/"
//  "serverUrl": "https://iekbc01i45.execute-api.ap-northeast-1.amazonaws.com/prod/"
}
